/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable comma-style */
/* eslint-disable no-undef */
import { FirebaseWeb } from './firebaseWeb';

const props = [];

export const FirebaseWebDirective = (reactDirective) => reactDirective(FirebaseWeb, props);
FirebaseWebDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('firebaseWeb', FirebaseWebDirective);
